import {
  DesignClass,
  FunctionType,
  NodeTypeName,
  ObjectClass
} from "@app/types";
import { createUuid } from "./functions";
import Utility from "./Utility.js";

export default class CreateObjects {
  constructor(props) { }
  static createModule() {
    const treeDom = $("#tl_container");

    var newModule = {
      id: createUuid(),
      name: window.apm.getEligibleTreeName(
          treeDom,
        "UNTITLED_NODE",
        "module",
        "module"
      ),
      type: "module",
      _class: DesignClass.module,
      props: {
        iconClass: "package",
        config: {
          description: "ModuleDescription"
        }
      },
      version: "1",
      versions: {
        "1": {
          version: "1",
          flow: {
            offsetX: 0,
            offsetY: 0,
            zoom: 100,
            links: [],
            nodes: [
              {
                id: createUuid(),
                _class: ObjectClass.begin,
                x: 720,
                y: 80,
                name: "Begin",
                props: {
                  colorClass: "purple",
                  iconClass: "log-in",
                  createdTime: window.apm.timestamp,
                  lastLocalChange: window.apm.timestamp,
                  error: {},
                  config: {
                    description: "Entry point of the module",
                    "inputs":[]
                  }
                }
              }
            ]
          }
        }
      },
      localVariables: []
    };
    treeDom
      .jstree()
      .create_node("modules", Utility.getTreeNode(newModule), "last", function (
        new_node
      ) {
        treeDom.jstree().deselect_all();

      });
    newModule.props.parentComponentID = newModule.id;
    newModule.props.ref = newModule.id;
    window.apm.addNode(newModule);

    return newModule;
  }
  static createCustom() {
    const treeDom = $("#tl_container");

    var custom = {
      id: createUuid(),
      _class: ObjectClass.custom,
      type: "object",

      name: window.apm.getEligibleTreeName(
          treeDom,
        "CUSTOM",
        "object",
        NodeTypeName.custom
      ),
      props: {
        nodeTypeName: NodeTypeName.custom,
        colorClass: " green",
        iconClass: "cpu",
        createdTime: window.apm.timestamp,
        lastLocalChange: window.apm.timestamp,
        config: {
          description: "Run custom script",
          functionType: FunctionType.custom,
          function: {
            script: ""
          }

        }

      }
    };

    if (!treeDom.jstree().get_node(custom.props.nodeTypeName)) {
      // add type name folder if not exist
      treeDom.jstree().create_node(
        "objects",
        {
          id: custom.props.nodeTypeName,
          text: custom.props.nodeTypeName,
          type: "objects",
          state: { opened: true },
          children: [Utility.getTreeNode(custom)]
        },
        "last"
      );
    } else {
      treeDom
        .jstree()
        .create_node(
          custom.props.nodeTypeName,
          Utility.getTreeNode(custom),
          "last"
        );
    }
    custom.props.parentComponentID = custom.id;
    window.apm.addNode(custom);

    return custom;
  }
  static createPrompt() {
    const treeDom = $("#tl_container");
    
    const prompt = {
      id: createUuid(),
      _class: ObjectClass.prompt,
      type: "object",
      name: window.apm.getEligibleTreeName(treeDom, "PROMPT", "object", NodeTypeName.prompt),
      props: {
        nodeTypeName: NodeTypeName.prompt,
        colorClass: " orange",
        iconClass: "message-square",
        createdTime: window.apm.timestamp,
        lastLocalChange: window.apm.timestamp,
        config: {
          description: "Prompt user with predefined text",
          inputs: [],
          text: {
            "en-US" :""
          },
          bargeable: "DISABLED",
          dynamicPromptType: "TTP",
          repeatable: true,
          dynamic:false
        }
      }
    };

    if (!treeDom.jstree().get_node(prompt.props.nodeTypeName)) {
      // add type name folder if not exist
      treeDom.jstree().create_node(
        "objects",
        {
          id: prompt.props.nodeTypeName,
          text: prompt.props.nodeTypeName,
          type: "objects",
          state: { opened: true },
          children: [Utility.getTreeNode(prompt)]
        },
        "last"
      );
    } else {
      treeDom
        .jstree()
        .create_node(
          prompt.props.nodeTypeName,
          Utility.getTreeNode(prompt),
          "last"
        );
    }
    
    if(window.apm.serialized.omniChannel.isOmniChannel){
      prompt.channel = {};
      prompt.channel["voice"] = {"en-US": ""}
    }

    prompt.props.parentComponentID = prompt.id;
    window.apm.addNode(prompt);

    return prompt;
  }

  static createInput() {
    const treeDom = $("#tl_container");

    var input = {
      id: createUuid(),
      _class: ObjectClass.input,
      type: "object",

      name: window.apm.getEligibleTreeName(treeDom, "INPUT", "object", NodeTypeName.input),
      props: {
        nodeTypeName: NodeTypeName.input,
        colorClass: "blue",
        iconClass: "mic",
        createdTime: window.apm.timestamp,
        lastLocalChange: window.apm.timestamp,
        config: {
          description: "User voice input",
          sensitiveData: false
        }
      }
    };

    if (!treeDom.jstree().get_node(input.props.nodeTypeName)) {
      // add type name folder if not exist
      treeDom.jstree().create_node(
        "objects",
        {
          id: input.props.nodeTypeName,
          text: input.props.nodeTypeName,
          type: "objects",
          state: { opened: true },
          children: [Utility.getTreeNode(input)]
        },
        "last"
      );
    } else {
      treeDom
        .jstree()
        .create_node(
          input.props.nodeTypeName,
          Utility.getTreeNode(input),
          "last"
        );
    }

    input.props.parentComponentID = input.id;
    window.apm.addNode(input);

    return input;
  }
}
